import script from "./ProtocolFileView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProtocolFileView.vue?vue&type=script&setup=true&lang=ts"

import "./ProtocolFileView.vue?vue&type=style&index=0&id=d78ba61c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d78ba61c"]])

export default __exports__